import { connect } from 'react-redux'
import SlideConstructor from './slide-constructor.jsx'
import { getActiveSlideId } from '../redux/builder.selectors'
import {
  getSlide,
  getPresentation,
  getSlidesMap
} from '../../../../../stores/presentation/presentation.selectors'
import { directSlideUpdate } from '../../../../../stores/presentation/presentation.actions.js'

const mapStateToProps = state => {
  const presentation = getPresentation(state)
  const slide = getSlide(state, getActiveSlideId(state))
  return {
    id: slide.id,
    fontSize: presentation.font_size,
    presentation,
    slides: getSlidesMap(state),
    activeSlideId: getActiveSlideId(state)
  }
}

const mapDispatchToProps = dispatch => ({
  onSlideUpdate: slide => dispatch(directSlideUpdate(slide))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SlideConstructor)
